'use client';

import HomeSearchSamples from '@/app/(public)/(home)/home-search-samples';
import SearchTextarea from '@/app/(public)/(home)/search-textarea';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function HomeSearchPanel() {
  const searchParams = useSearchParams();
  const q = searchParams.get('q') ?? '';
  const [query, setQuery] = useState(q);

  useEffect(() => {
    setQuery(q);
  }, [q]);

  return (
    <>
      <div className="w-full max-w-196 mx-auto mt-2">
        <SearchTextarea value={query} onValueChange={setQuery} />
      </div>
      <HomeSearchSamples onSelectQuery={setQuery} />
    </>
  );
}
